import ToDo from "./ToDo";

function App() {
  return (
    <>
      <ToDo />
    </>
  );
}

export default App;
